/* Inferno (Odyssey wood butts): the hero embers, the draw calendar, the
   receipt switch and loyal link, the buy button's label, and the phone bar.
   Nothing here touches the cart: Dawn's product form does all of that. */
(() => {
  if (window.kpInfernoReady) return;
  window.kpInfernoReady = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');

  /* ── embers: a slow drift off the burning grain, the hero's one moving
     thing. Runs only while the hero is on screen; under reduced motion one
     still frame is drawn and nothing moves. ── */
  function embers(cv) {
    const ctx = cv.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let w = 0, h = 0, raf = 0, on = false, last = 0;
    const ps = [];
    const size = () => {
      const r = cv.getBoundingClientRect();
      w = r.width; h = r.height;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    /* data-speed / data-density scale the drift for a louder surface (the BF banner). */
    const sp = parseFloat(cv.dataset.speed) || 1;
    const dense = parseFloat(cv.dataset.density) || 1;
    const spawn = (p, fresh) => {
      p.x = Math.random() * w;
      p.y = fresh ? h * (0.3 + Math.random() * 0.7) : h + 6;
      p.r = 0.7 + Math.random() * 1.5;
      p.vy = (0.12 + Math.random() * 0.28) * sp;
      p.vx = (Math.random() - 0.5) * 0.08;
      p.max = (9000 + Math.random() * 7000) / Math.sqrt(sp);
      p.age = fresh ? Math.random() * p.max * 0.6 : 0;
      p.ph = Math.random() * 6.28;
    };
    const draw = (dt) => {
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      for (const p of ps) {
        p.age += dt;
        p.y -= p.vy * dt * 0.06;
        p.x += p.vx * dt * 0.06 + Math.sin(p.age / 1400 + p.ph) * 0.08;
        const k = 1 - p.age / p.max;
        if (k <= 0 || p.y < -6) { spawn(p, false); continue; }
        const a = Math.min(1, k * 1.6) * Math.min(1, p.age / 1200) * (0.35 + 0.65 * p.y / h);
        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 5);
        g.addColorStop(0, `rgba(255,214,150,${a})`);
        g.addColorStop(0.3, `rgba(255,107,0,${a * 0.75})`);
        g.addColorStop(1, 'rgba(224,16,30,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 5, 0, 6.283); ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
    };
    const loop = (t) => {
      const dt = last ? Math.min(64, t - last) : 16;
      last = t; draw(dt);
      if (on) raf = requestAnimationFrame(loop);
    };
    size();
    for (let i = 0; i < Math.round(Math.max(12, w / 12) * dense); i++) { const p = {}; spawn(p, true); ps.push(p); }
    if (reduce) { draw(0); return; }
    new IntersectionObserver(([en]) => {
      on = en.isIntersecting; cancelAnimationFrame(raf); last = 0;
      if (on) raf = requestAnimationFrame(loop);
    }).observe(cv);
    window.addEventListener('resize', () => { size(); draw(0); });
  }

  /* ── the draw: dates come from the draw section's blocks ── */
  function drawState(dates, now = Date.now()) {
    const upcoming = dates.filter((d) => d.at > now);
    const ms = upcoming[0] ? upcoming[0].at - now : 0;
    return { next: upcoming[0], entries: upcoming.length, days: Math.floor(ms / 864e5), hours: Math.floor((ms % 864e5) / 36e5), mins: Math.floor((ms % 36e5) / 6e4) };
  }
  function readDates() {
    const el = document.querySelector('[data-kp-inferno-draw-dates]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).map((d) => ({ ...d, at: Date.parse(d.at) })).filter((d) => !Number.isNaN(d.at));
    } catch (e) { return null; }
  }
  function paintDraw() {
    const dates = readDates();
    if (!dates) return;
    const s = drawState(dates);
    document.querySelectorAll('[data-kp-inferno-date]').forEach((cell) => {
      cell.classList.toggle('is-next', !!s.next && cell.dataset.kpInfernoDate === String(s.next.i));
      cell.classList.toggle('is-past', Date.parse(cell.dataset.at) <= Date.now());
    });
    document.querySelectorAll('[data-kp-inferno-entries]').forEach((n) => {
      if (n.textContent !== String(s.entries)) {
        const first = n.textContent === '';
        n.textContent = s.entries;
        if (!first && !reduce) { n.classList.remove('is-in'); void n.offsetWidth; n.classList.add('is-in'); }
      }
    });
    document.querySelectorAll('[data-kp-inferno-cd="d"]').forEach((n) => { n.textContent = pad(s.days); });
    document.querySelectorAll('[data-kp-inferno-cd="h"]').forEach((n) => { n.textContent = pad(s.hours); });
    document.querySelectorAll('[data-kp-inferno-cd="m"]').forEach((n) => { n.textContent = pad(s.mins); });
    document.querySelectorAll('[data-kp-inferno-live]').forEach((n) => { n.hidden = s.entries === 0; });
    document.querySelectorAll('[data-kp-inferno-drawline]').forEach((line) => {
      const t = line.querySelector('[data-kp-inferno-drawline-text]');
      if (t) t.textContent = line.dataset.text.replace('[n]', s.entries);
      line.hidden = s.entries === 0;
    });
  }

  /* ── the buy button keeps the price; the phone bar follows ── */
  function setPrice(scope, price, label) {
    const btn = document.getElementById(scope.dataset.formButton);
    if (btn && !btn.disabled && label) {
      const span = btn.querySelector('span');
      if (span) span.textContent = `${label} · ${price}`;
    }
    document.querySelectorAll('[data-kp-inferno-price]').forEach((n) => { n.textContent = price; });
  }

  class KpInfernoReceipt extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('.kp-pdp-ladder__input[value="text"]');
      const cookie = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1];
      const vip = this.dataset.vipCode && cookie && decodeURIComponent(cookie).toUpperCase() === this.dataset.vipCode.toUpperCase();
      if (vip) {
        this.setAttribute('data-vip', '');
        const row = this.querySelector('[data-kp-row="vip"]');
        if (row) row.hidden = false;
        if (text) text.checked = false;
      }
      const update = () => {
        const price = vip ? this.dataset.priceVip : (text && text.checked ? this.dataset.priceText : this.dataset.priceCode);
        setPrice(this, price, this.dataset.cta);
      };
      if (text) text.addEventListener('change', update);
      update();
    }
  }
  if (!customElements.get('kp-inferno-receipt')) customElements.define('kp-inferno-receipt', KpInfernoReceipt);

  function soldLabel() {
    document.querySelectorAll('[data-kp-inferno-sold-label]').forEach((head) => {
      const btn = document.getElementById(head.dataset.formButton);
      if (btn && btn.disabled) {
        const span = btn.querySelector('span');
        if (span) span.textContent = head.dataset.kpInfernoSoldLabel;
      }
    });
  }

  function sticky() {
    document.querySelectorAll('[data-kp-inferno-sticky]').forEach((bar) => {
      const btn = document.getElementById(bar.dataset.formButton);
      if (!btn) return;
      /* fixed to the viewport, so it lives on <body>: a transformed or contained
         buy-box column would otherwise become its containing block */
      document.body.appendChild(bar);
      bar.hidden = false;
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.toggleAttribute('data-shown', past);
      }).observe(btn);
    });
  }

  function init() {
    document.querySelectorAll('canvas.kp-inferno-embers').forEach(embers);
    paintDraw();
    setInterval(paintDraw, 60000);
    soldLabel();
    sticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
